import React, { useRef, useState } from 'react'
import Options from './Options'

//modals
import Question from '../../../../modals/messages/Question'
import Error from '../../../../modals/messages/Error'
import EditPart from '../modals/AddEditPart'

// images
import loader from '../../../../../assets/img/loader.svg'
import markPartsImage from "@/assets/img/reservations/icons/give-parts.svg"

import Api from '../../../../../_helpers/Api'
import checkIcon from '../../../../../assets/img/icons/check.png'
import crossIcon from '../../../../../assets/img/icons/close.png'
import { trans } from '../../../../../_providers/Translation'
import TableFiles from './TableFiles'
import { useCurrencyContext } from '../../../../../_providers/Currency'
import { Checkbox, FormControlLabel } from '@mui/material'
import moment from 'moment'

function Table(props) {
    const currencies = useCurrencyContext()

    const [loadingGiven, setLoadingGiven] = useState(false)

    const { data: parts } = props.parts || []
    //refs
    const questionModalRef = useRef(null)
    const errorModalRef = useRef(null)
    const editPartModalRef = useRef(null)

    const reservation = props.reservation

    const handleDeletePart = id => {
        let modal = questionModalRef.current

        modal.open(id)

        modal.onSuccess(() => {
            props.handleDeletePart(id)
        })
    }

    const handleEditPart = id => {

        let modal = editPartModalRef.current

        modal.edit(id)

        modal.onSave(part => {
            props.handleUpdatePart(part)
        })

    }

    const handleTransferAll = e => {
        let date = document.getElementById('give-date').value

        if (props.selectedPartsIds.length) {
            setLoadingGiven(true)

            Api.post('ordered-parts/transfer', {
                ids: props.selectedPartsIds,
                date: date
            }).then(res => {
                props.refreshData()
            })
                .finally(() => {
                    setLoadingGiven(false)
                })
        }
    }

    const markToIncludeInOffer = (e, id) => {
        props.setSelectedPartsIds(prev =>
            e.target.checked ? [...prev, id] : prev.filter(x => x !== id)
        )
    }

    const includeAllInOffer = (e) => {
        const checked = e.target.checked

        if (checked) {
            const allIds = props.data.map(row => row.id)
            props.setSelectedPartsIds(allIds)
        } else {
            props.setSelectedPartsIds([])
        }
    }

    const includeLabourInQuote = () => {
        props.setToIncludeLabourInQuote(prev => !prev)
    }

    return (

        props.loading
            ?
            <img src={loader} alt="loading" />
            :
            <>
                <Question
                    ref={questionModalRef}
                    mainMessage={trans('headings.question12')}
                />

                <Error
                    ref={errorModalRef}
                    mainMessage={trans('headings.error3')}
                />

                <EditPart
                    ref={editPartModalRef}
                    reservation={reservation}
                />

                {props.data.length == 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noResultsFound')}
                    </div>
                    :
                    <>
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        {/* YK: ЧАСТИ - 7а */}
                                        <th className="checkbox">
                                            <Checkbox
                                                checked={props.selectedPartsIds.length > 0 && props.selectedPartsIds.length === props.data.length}
                                                indeterminate={props.selectedPartsIds.length > 0 && props.selectedPartsIds.length < props.data.length}
                                                onChange={(e) => includeAllInOffer(e)}
                                                size='small'
                                            />
                                        </th>
                                        <th>ID</th>
                                        <th>{trans('tables.name')}</th>
                                        {!(reservation.is_copy && !Number(reservation.can_see_parts_batch_numbers)) &&
                                            <th>{trans('tables.partNumber')}</th>
                                        }
                                        <th>{trans('tables.source')}</th>
                                        <th className="center">{trans('tables.location')}</th>
                                        <th className="center">{trans('tables.quantity')}</th>
                                        <th>{trans('tables.status')}</th>
                                        {!(reservation.is_copy && !Number(reservation.can_see_part_prices)) &&
                                            <th>{trans('tables.grossPrice')}</th>
                                        }
                                        <th className="center">{trans('tables.given')}</th>
                                        <th>
                                            {props.reservation.can_modify && props.reservation.can_modify_parts &&
                                                <th className="options">{trans('tables.options')}</th>
                                            }
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.data.map(row =>
                                        <tr key={'p-' + row.id}>
                                            <td
                                                className="checkbox"
                                                style={{
                                                    paddingLeft: '20px'
                                                }}
                                            >
                                                <Checkbox
                                                    className="mark-offer"
                                                    checked={props.selectedPartsIds.includes(row.id)}
                                                    onChange={(e) => markToIncludeInOffer(e, row.id)}
                                                    data-id={row.id}
                                                    size='small'
                                                />
                                            </td>
                                            <td>
                                                {row.id}
                                            </td>
                                            <td>
                                                {row.name}
                                            </td>
                                            {!(reservation.is_copy && !Number(reservation.can_see_parts_batch_numbers)) &&
                                                <td>
                                                    {row.number || '-'}
                                                </td>
                                            }
                                            <td>
                                                {row.source === 'SERVICE'
                                                    ? trans('random.sourceService')
                                                    : row.source === 'EMPLOYEE'
                                                        ? trans('random.sourceEmployee')
                                                        :
                                                        ''
                                                }
                                            </td>
                                            <td className="center">
                                                {row.total_quantity > 0 ? trans('random.inStock') : trans('random.noStock')}
                                            </td>
                                            <td className="center">
                                                {row.quantity}
                                            </td>

                                            <td>
                                                {row.status && row.status.name}

                                            </td>

                                            {!(reservation.is_copy && !Number(reservation.can_see_part_prices)) &&
                                                <td>
                                                    {row.gross_price_format} {row.currency.name}
                                                </td>
                                            }

                                            <td className="center">
                                                {row.given && <img src={checkIcon} alt="given" height="8" />}
                                            </td>

                                            {props.reservation.can_modify &&
                                                <td
                                                    style={{
                                                        paddingRight: '20px'
                                                    }}
                                                    className="options"
                                                >
                                                    <Options
                                                        id={row.id}
                                                        editable={true}
                                                        deletable={row.deletable}
                                                        handleDeletePart={handleDeletePart}
                                                        handleEditPart={handleEditPart}
                                                    />
                                                </td>
                                            }
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <hr />
                            <div
                                className='row'
                                style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <div>
                                    <div
                                        className='row'
                                        style={{
                                            gap: "10px",
                                            alignItems: "center"
                                        }}
                                    >
                                        <input
                                            id="give-date"
                                            type="datetime-local"
                                            defaultValue={moment().format("YYYY-MM-DDTHH:mm")}
                                        />
                                        <button
                                            onClick={handleTransferAll}
                                            className='button button-default button-small'
                                            disabled={props.selectedPartsIds.length === 0 || loadingGiven}
                                        >
                                            <img src={markPartsImage} alt="mark parts" />
                                            {trans('random.markUp')}
                                        </button>
                                    </div>
                                </div>
                                {!(reservation.is_copy && !Number(reservation.can_see_labour_price)) &&
                                <div>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                onChange={(e) => includeLabourInQuote()}
                                                size='small'
                                            />
                                        }
                                        label={`${trans('labels.includeLabourInQuote')} (+${parseFloat(props.reservation.labour_price).toFixed(2)} ${currencies.find(c => c.id === props.reservation.currency_id)?.name || ''}).`}
                                        sx={{
                                            paddingLeft: '12px',
                                        }}
                                    />
                                </div>
                                }
                            </div>
                        </div>
                    </>
                }

            </>

    )
}

export default Table